// src/index.js
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { NavigationProvider } from './providers/NavigationContext';
import { ScannerSettingsProvider } from './providers/ScannerSettingsContext';

// foundational import
import { BarcodeReader } from 'dynamsoft-javascript-barcode';
const baseUrl = document.getElementsByTagName('base')[0]?.getAttribute('href') || '/';
const root = createRoot(document.getElementById('root'));

(async () => {
  try {
    BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAzMDUzNzM5LU1UQXpNRFV6TnpNNUxYZGxZaTFVY21saGJGQnliMm8iLCJtYWluU2VydmVyVVJMIjoiaHR0cHM6Ly9tZGxzLmR5bmFtc29mdG9ubGluZS5jb20iLCJvcmdhbml6YXRpb25JRCI6IjEwMzA1MzczOSIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NkbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsImNoZWNrQ29kZSI6MTUwNjA0ODg0Nn0=';
    
  // tell it exactly where to fetch the *.wasm and *.worker.js
 await BarcodeReader.loadWasm();

    console.log('✔️ Dynamsoft foundational SDK licensed');
  } catch (e) {
    console.error('❌ License init failed', e);
  } finally {
    root.render(
      <BrowserRouter basename={baseUrl}>
        <NavigationProvider>
          <ScannerSettingsProvider>
            <App />
          </ScannerSettingsProvider>
        </NavigationProvider>
      </BrowserRouter>
    );
  }
})();

serviceWorkerRegistration.unregister();
reportWebVitals();
